import React from 'react';
import { navigate } from 'gatsby';

//CORE COMPONENTS
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { Button } from '../../../components-core/packages/components-core/dist/button/index';
import { Link } from '../../../components-core/packages/components-core/dist/link/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { 
    Container, 
    ContainerGutter, 
    ContainerWrap,
    ContainerHorizontalAlignment, 
    ContainerVerticalAlignment,
    ContainerPadding
} from '../../../components-core/packages/components-core/dist/container/index';

import {
    ThemeProvider,
    styled
} from '../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Text,
    TextAppearance,
    TextColor,
    TextAlignment,
} from '../../../components-core/packages/components-core/dist/text/index';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';

//ICONS CORE
import { Checkmark } from '../../../components-core/packages/icons-core/dist/Checkmark/index';


const ColorContainer = styled.div`
    background-color: ${props => props.backgroundColor};
    min-height: 180px;
    padding-top: 24px;
    width: 100%;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 24px;
`;

const CenterContentContainer = styled(ContentContainer)`
    align-items: center;
`;

const ImageContainer = styled.div`
    margin-top: -22%;
`;

const TextContainer = styled.div`
    padding: 0 32px 0 32px;
`; 


class PriceArea extends React.Component {

    //MODE ONE SECTION
    
    renderPrice() {
        return (
            <Text textAlign={TextAlignment.center}  appearance={TextAppearance.label0200} >
                <b>{this.props.data.price}</b>'den başlayan fiyatlarla
            </Text>  
        )
    }

    renderButton(modelLink) {
        return (
            <Container 
                stretchContent={true} 
                padding={{ 
                    top: ContainerPadding.dynamic0050,
                    bottom: ContainerPadding.dynamic0050
                }}
            >
                <Button stretchContent={true} onClick={() => window.open(modelLink)}>
                    <Text 
                        appearance={TextAppearance.label0150} 
                        color={TextColor.inherit}
                    >
                        İncele
                    </Text>
                </Button>
            </Container>
        )
    }

    renderLink() {
        return (
            <Link isInline href={'#'} >
                <Text 
                    bold={true}
                    appearance={TextAppearance.copy0200} 
                    color={TextColor.inherit}
                >
                    Modelleri İncele
                </Text>
            </Link>
        )
    }

    renderModeOne(modelLink) {
        return (
            <CenterContentContainer>
                {this.renderButton(modelLink)}
            </CenterContentContainer>
        )
    }


    //MODE TWO SECTION

    renderLeftAlignedPrice() {
        return (
            <Container wrap={ContainerWrap.always}>
                <Text appearance={TextAppearance.label0200} >
                    <b>{this.props.data.price}</b>'den başlayan fiyatlarla
                </Text>  
            </Container>
        )
    }
    

    renderPack() {
        return (
            <Container 
                padding={{ top: ContainerPadding.dynamic0050 }} 
            >
                <Text appearance={TextAppearance.copy0150} >Comfortline donanımına ek*</Text>
            </Container>
        )
    }

    renderListItem() {
        return (
            <Container 
                wrap={ContainerWrap.never} 
                gutter={ContainerGutter.static300} 
                padding={{ bottom: ContainerPadding.static150 }}
            >
                <Checkmark variant={'small'} />
                <Text appearance={TextAppearance.copy0150}>Bi-Xenon Farlar</Text>
            </Container>
        )
    }

    renderModeTwo(modelLink) {
        return (
            <Container 
                wrap={ContainerWrap.always}
                padding={{
                    top: ContainerPadding.dynamic0150,
                    left: {
                        [Breakpoints.default]: ContainerPadding.grid002,
                        [Breakpoints.b560]: null
                    },
                    right: {
                        [Breakpoints.default]: ContainerPadding.grid002,
                        [Breakpoints.b560]: null
                    }                    
                }}
            >
                {this.renderLeftAlignedPrice()}
                {this.renderPack()}
                <Container 
                    wrap={ContainerWrap.always} 
                    padding={{ top: ContainerPadding.dynamic0050 }} 
                >
                    {this.renderListItem()}
                    {this.renderListItem()}
                    {this.renderListItem()}
                    {this.renderListItem()}
                </Container>
                {this.renderButton(modelLink)}
            </Container>
        )
    }

    render() {
        return [
            <ThemeProvider theme={'image'} >
                <ColorContainer backgroundColor={this.props.data.backgroundColor}>
                    <TextContainer>
                        <Text bold appearance={TextAppearance.headline0250} >
                            {this.props.data.title}
                        </Text>
                    </TextContainer>
                </ColorContainer>
            </ThemeProvider>,
            <ThemeProvider theme={'main'} >
                <ImageContainer>
                    <Image 
                        src={this.props.data.image}
                        alt={this.props.data.title}
                    />
                </ImageContainer>
                {this.props.mode === 1 ? this.renderModeOne(this.props.data.modelLink) : this.renderModeTwo(this.props.data.modelLink)}
            </ThemeProvider>
        ]
    }
}

export default PriceArea;